<template>
  <div class="input-box">
    <div v-text="placeholderValue" class="placeholder-box"></div>
    <input
      v-model="value"
      :style="radiusStyle"
      :type="type"
      @focus="focused=true"
      @blur="focused=false"
    />
  </div>
</template>

<script>
import BorderMixin from './mixins/BorderMixin'
import { EVENT } from '@/constants/event'

export default {
  name: 'GSInput',
  mixins: [BorderMixin],
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    digitOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: '',
      focused: false
    }
  },
  computed: {
    placeholderValue () {
      return this.focused || this.value ? '' : (this.placeholder || '')
    }
  },
  watch: {
    value (val) {
      if (this.digitOnly) {
        this.value = val.replace(/\D/g, '')
      }
      this.$emit(EVENT.CHANGED, this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.input-box {
  background: #12232D;
  border-radius: $radius-size;
  position: relative;
  width: 100%;
  height: $base-size * 90;
  padding: $base-size * 25 $base-size * 30;
  font-size: $font-size-s;
  color: #88A7BA;

  .placeholder-box {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0);
    border: 1px solid #435B69;
    color: #31BEFF;
    padding: $base-size * 26 $base-size * 30;
    font-size: $font-size-s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSInput.vue